var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 16.6667H18.3334",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 8.33334H9.16665",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.6667V17.6667C17.219 17.6667 17.6667 17.219 17.6667 16.6667H16.6667ZM11.6667 16.6667H10.6667C10.6667 17.219 11.1144 17.6667 11.6667 17.6667V16.6667ZM12.5 8.5H15.8334V6.5H12.5V8.5ZM15.6667 8.33333V16.6667H17.6667V8.33333H15.6667ZM16.6667 15.6667H11.6667V17.6667H16.6667V15.6667ZM12.6667 16.6667V8.33333H10.6667V16.6667H12.6667ZM15.8334 8.5C15.7413 8.5 15.6667 8.42538 15.6667 8.33333H17.6667C17.6667 7.32081 16.8459 6.5 15.8334 6.5V8.5ZM12.5 6.5C11.4875 6.5 10.6667 7.32081 10.6667 8.33333H12.6667C12.6667 8.42538 12.5921 8.5 12.5 8.5V6.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 5.83334L9.16665 5.83334",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 16.6667V17.6667C12.2189 17.6667 12.6666 17.219 12.6666 16.6667H11.6666ZM3.33331 16.6667H2.33331C2.33331 17.219 2.78103 17.6667 3.33331 17.6667V16.6667ZM4.16665 3.5H10.8333V1.5H4.16665V3.5ZM10.6666 3.33333V16.6667H12.6666V3.33333H10.6666ZM11.6666 15.6667H3.33331V17.6667H11.6666V15.6667ZM4.33331 16.6667V3.33333H2.33331V16.6667H4.33331ZM10.8333 3.5C10.7413 3.5 10.6666 3.42538 10.6666 3.33333H12.6666C12.6666 2.32081 11.8458 1.5 10.8333 1.5V3.5ZM4.16665 1.5C3.15412 1.5 2.33331 2.32081 2.33331 3.33333H4.33331C4.33331 3.42538 4.25869 3.5 4.16665 3.5V1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.21ff739d.svg";
export { ForwardRef as ReactComponent };